/**
 *
 * carbon-angular v0.0.0 | carbon-components-angular-breadcrumb.js
 *
 * Copyright 2014, 2023 IBM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0

 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Component, HostBinding, Input, Output, EventEmitter, Optional, ContentChildren, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'carbon-components-angular/dialog';
import { I18n, I18nModule } from 'carbon-components-angular/i18n';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from 'carbon-components-angular/i18n';
import * as ɵngcc5 from 'carbon-components-angular/dialog';

function BreadcrumbItemComponent_a_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BreadcrumbItemComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 2);
    ɵngcc0.ɵɵlistener("click", function BreadcrumbItemComponent_a_0_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.navigate($event)); });
    ɵngcc0.ɵɵtemplate(1, BreadcrumbItemComponent_a_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("href", ctx_r0.skeleton ? "/#" : ctx_r0.href, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵattribute("aria-current", ctx_r0.current ? ctx_r0.ariaCurrent : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function BreadcrumbItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c0 = ["*"];
function Breadcrumb_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r5.content);
} }
function Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_2_ng_template_0_Template(rf, ctx) { }
const _c1 = function (a0) { return { $implicit: a0 }; };
function Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_2_ng_template_0_Template, 0, 0, "ng-template", 6);
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r5.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, item_r5));
} }
function Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ibm-breadcrumb-item", 4);
    ɵngcc0.ɵɵlistener("navigation", function Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_Template_ibm_breadcrumb_item_navigation_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r11.navigation.emit($event)); });
    ɵngcc0.ɵɵtemplate(1, Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_ng_container_1_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_2_Template, 1, 4, null, 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("href", item_r5.href)("route", item_r5.route)("routeExtras", item_r5.routeExtras)("current", item_r5.current)("ariaCurrent", item_r5.ariaCurrent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r5.template);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.template);
} }
function Breadcrumb_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, Breadcrumb_ng_template_3_ibm_breadcrumb_item_0_Template, 3, 7, "ibm-breadcrumb-item", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.items);
} }
function Breadcrumb_ng_template_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r13.first == null ? null : ctx_r13.first.content);
} }
function Breadcrumb_ng_template_4_2_ng_template_0_Template(rf, ctx) { }
function Breadcrumb_ng_template_4_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, Breadcrumb_ng_template_4_2_ng_template_0_Template, 0, 0, "ng-template", 6);
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r14.first == null ? null : ctx_r14.first.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r14.first));
} }
function Breadcrumb_ng_template_4_li_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r21 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r21 == null ? null : item_r21.content);
} }
function Breadcrumb_ng_template_4_li_5_3_ng_template_0_Template(rf, ctx) { }
function Breadcrumb_ng_template_4_li_5_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, Breadcrumb_ng_template_4_li_5_3_ng_template_0_Template, 0, 0, "ng-template", 6);
} if (rf & 2) {
    const item_r21 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r21 == null ? null : item_r21.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, item_r21));
} }
function Breadcrumb_ng_template_4_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 8)(1, "a", 9);
    ɵngcc0.ɵɵlistener("click", function Breadcrumb_ng_template_4_li_5_Template_a_click_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r28); const item_r21 = restoredCtx.$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r27.navigate($event, item_r21)); });
    ɵngcc0.ɵɵtemplate(2, Breadcrumb_ng_template_4_li_5_ng_container_2_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(3, Breadcrumb_ng_template_4_li_5_3_Template, 1, 4, null, 5);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r21 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", item_r21 == null ? null : item_r21.href, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(item_r21 == null ? null : item_r21.template));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r21 == null ? null : item_r21.template);
} }
function Breadcrumb_ng_template_4_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r16.secondLast == null ? null : ctx_r16.secondLast.content);
} }
function Breadcrumb_ng_template_4_8_ng_template_0_Template(rf, ctx) { }
function Breadcrumb_ng_template_4_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, Breadcrumb_ng_template_4_8_ng_template_0_Template, 0, 0, "ng-template", 6);
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r17.secondLast == null ? null : ctx_r17.secondLast.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r17.secondLast));
} }
function Breadcrumb_ng_template_4_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r18.last == null ? null : ctx_r18.last.content);
} }
function Breadcrumb_ng_template_4_11_ng_template_0_Template(rf, ctx) { }
function Breadcrumb_ng_template_4_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, Breadcrumb_ng_template_4_11_ng_template_0_Template, 0, 0, "ng-template", 6);
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r19.last == null ? null : ctx_r19.last.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r19.last));
} }
function Breadcrumb_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ibm-breadcrumb-item", 4);
    ɵngcc0.ɵɵlistener("navigation", function Breadcrumb_ng_template_4_Template_ibm_breadcrumb_item_navigation_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r31.navigation.emit($event)); });
    ɵngcc0.ɵɵtemplate(1, Breadcrumb_ng_template_4_ng_container_1_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, Breadcrumb_ng_template_4_2_Template, 1, 4, null, 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "ibm-breadcrumb-item")(4, "ibm-overflow-menu");
    ɵngcc0.ɵɵtemplate(5, Breadcrumb_ng_template_4_li_5_Template, 4, 3, "li", 7);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "ibm-breadcrumb-item", 4);
    ɵngcc0.ɵɵlistener("navigation", function Breadcrumb_ng_template_4_Template_ibm_breadcrumb_item_navigation_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r33.navigation.emit($event)); });
    ɵngcc0.ɵɵtemplate(7, Breadcrumb_ng_template_4_ng_container_7_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(8, Breadcrumb_ng_template_4_8_Template, 1, 4, null, 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "ibm-breadcrumb-item", 4);
    ɵngcc0.ɵɵlistener("navigation", function Breadcrumb_ng_template_4_Template_ibm_breadcrumb_item_navigation_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r34.navigation.emit($event)); });
    ɵngcc0.ɵɵtemplate(10, Breadcrumb_ng_template_4_ng_container_10_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(11, Breadcrumb_ng_template_4_11_Template, 1, 4, null, 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r3.first == null ? null : ctx_r3.first.href)("route", ctx_r3.first == null ? null : ctx_r3.first.route)("routeExtras", ctx_r3.first == null ? null : ctx_r3.first.routeExtras)("current", ctx_r3.first == null ? null : ctx_r3.first.current)("ariaCurrent", ctx_r3.first == null ? null : ctx_r3.first.ariaCurrent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r3.first == null ? null : ctx_r3.first.template));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.first == null ? null : ctx_r3.first.template);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.overflowItems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r3.secondLast == null ? null : ctx_r3.secondLast.href)("route", ctx_r3.secondLast == null ? null : ctx_r3.secondLast.route)("routeExtras", ctx_r3.secondLast == null ? null : ctx_r3.secondLast.routeExtras)("current", ctx_r3.secondLast == null ? null : ctx_r3.secondLast.current)("ariaCurrent", ctx_r3.secondLast == null ? null : ctx_r3.secondLast.ariaCurrent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r3.secondLast == null ? null : ctx_r3.secondLast.template));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.secondLast == null ? null : ctx_r3.secondLast.template);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r3.last == null ? null : ctx_r3.last.href)("route", ctx_r3.last == null ? null : ctx_r3.last.route)("routeExtras", ctx_r3.last == null ? null : ctx_r3.last.routeExtras)("current", ctx_r3.last == null ? null : ctx_r3.last.current)("ariaCurrent", ctx_r3.last == null ? null : ctx_r3.last.ariaCurrent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r3.last == null ? null : ctx_r3.last.template));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.last == null ? null : ctx_r3.last.template);
} }
const _c2 = function (a0, a1) { return { "bx--skeleton": a0, "bx--breadcrumb--no-trailing-slash": a1 }; };
class BreadcrumbItemComponent {
    constructor(domSanitizer, router) {
        this.domSanitizer = domSanitizer;
        this.router = router;
        /**
         * Emits the navigation status promise when the link is activated
         */
        this.navigation = new EventEmitter();
        this.skeleton = false;
        this.ariaCurrent = "page";
        this.current = false;
        this.itemClass = true;
    }
    set href(v) {
        this._href = v;
    }
    get href() {
        return this.domSanitizer.bypassSecurityTrustUrl(this._href);
    }
    useTemplate() {
        return this.skeleton || this._href || this.route;
    }
    navigate(event) {
        if (this.router && this.route) {
            event.preventDefault();
            const status = this.router.navigate(this.route, this.routeExtras);
            this.navigation.emit(status);
        }
    }
}
BreadcrumbItemComponent.ɵfac = function BreadcrumbItemComponent_Factory(t) { return new (t || BreadcrumbItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router, 8)); };
BreadcrumbItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbItemComponent, selectors: [["ibm-breadcrumb-item"]], hostVars: 4, hostBindings: function BreadcrumbItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bx--breadcrumb-item--current", ctx.current)("bx--breadcrumb-item", ctx.itemClass);
    } }, inputs: { skeleton: "skeleton", ariaCurrent: "ariaCurrent", current: "current", href: "href", route: "route", routeExtras: "routeExtras" }, outputs: { navigation: "navigation" }, ngContentSelectors: _c0, decls: 3, vars: 2, consts: [["class", "bx--link", 3, "href", "click", 4, "ngIf", "ngIfElse"], ["content", ""], [1, "bx--link", 3, "href", "click"], [4, "ngTemplateOutlet"]], template: function BreadcrumbItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, BreadcrumbItemComponent_a_0_Template, 2, 3, "a", 0);
        ɵngcc0.ɵɵtemplate(1, BreadcrumbItemComponent_ng_template_1_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useTemplate())("ngIfElse", _r1);
    } }, dependencies: [ɵngcc3.NgIf, ɵngcc3.NgTemplateOutlet], encapsulation: 2 });
/** @nocollapse */
BreadcrumbItemComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router, decorators: [{ type: Optional }] }
];
BreadcrumbItemComponent.propDecorators = {
    href: [{ type: Input }],
    route: [{ type: Input }],
    routeExtras: [{ type: Input }],
    navigation: [{ type: Output }],
    skeleton: [{ type: Input }],
    ariaCurrent: [{ type: Input }],
    current: [{ type: HostBinding, args: ["class.bx--breadcrumb-item--current",] }, { type: Input }],
    itemClass: [{ type: HostBinding, args: ["class.bx--breadcrumb-item",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbItemComponent, [{
        type: Component,
        args: [{
                selector: "ibm-breadcrumb-item",
                template: `
	<a
		class="bx--link"
		[href]="(skeleton ? '/#' : href)"
		(click)="navigate($event)"
		[attr.aria-current]="(current ? ariaCurrent : null)"
		*ngIf="useTemplate(); else content">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</a>
	<ng-template #content>
		<ng-content></ng-content>
	</ng-template>`
            }]
    }], function () { return [{ type: ɵngcc1.DomSanitizer }, { type: ɵngcc2.Router, decorators: [{
                type: Optional
            }] }]; }, { navigation: [{
            type: Output
        }], skeleton: [{
            type: Input
        }], ariaCurrent: [{
            type: Input
        }], current: [{
            type: HostBinding,
            args: ["class.bx--breadcrumb-item--current"]
        }, {
            type: Input
        }], itemClass: [{
            type: HostBinding,
            args: ["class.bx--breadcrumb-item"]
        }], href: [{
            type: Input
        }], route: [{
            type: Input
        }], routeExtras: [{
            type: Input
        }] }); })();

const MINIMUM_OVERFLOW_THRESHOLD = 4;
/**
 *  [See demo](../../?path=/story/components-breadcrumb--basic)
 *
 * <example-url>../../iframe.html?id=components-breadcrumb--basic</example-url>
 */
class Breadcrumb {
    constructor(i18n, router) {
        this.i18n = i18n;
        this.router = router;
        this.noTrailingSlash = false;
        this.ariaLabel = this.i18n.get().BREADCRUMB.LABEL;
        /**
         * Emits the navigation status promise when the link is activated
         */
        this.navigation = new EventEmitter();
        this._skeleton = false;
    }
    set skeleton(value) {
        this._skeleton = value;
        this.updateChildren();
    }
    get skeleton() {
        return this._skeleton;
    }
    set threshold(threshold) {
        this._threshold = threshold;
        if (isNaN(threshold) || threshold < MINIMUM_OVERFLOW_THRESHOLD) {
            this._threshold = MINIMUM_OVERFLOW_THRESHOLD;
        }
    }
    get threshold() {
        return this._threshold;
    }
    get shouldShowContent() {
        return !this.items;
    }
    get shouldShowOverflow() {
        if (!this.items) {
            return false;
        }
        return this.items.length > this.threshold;
    }
    get first() {
        return this.shouldShowOverflow ? this.items[0] : null;
    }
    get overflowItems() {
        return this.shouldShowOverflow ? this.items.slice(1, this.items.length - 2) : [];
    }
    get secondLast() {
        return this.shouldShowOverflow ? this.items[this.items.length - 2] : null;
    }
    get last() {
        return this.shouldShowOverflow ? this.items[this.items.length - 1] : null;
    }
    ngAfterContentInit() {
        this.updateChildren();
    }
    navigate(event, item) {
        if (this.router && item.route) {
            event.preventDefault();
            const status = this.router.navigate(item.route, item.routeExtras);
            this.navigation.emit(status);
        }
    }
    updateChildren() {
        if (this.children) {
            this.children.toArray().forEach(child => child.skeleton = this.skeleton);
        }
    }
}
Breadcrumb.ɵfac = function Breadcrumb_Factory(t) { return new (t || Breadcrumb)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.I18n), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router, 8)); };
Breadcrumb.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: Breadcrumb, selectors: [["ibm-breadcrumb"]], contentQueries: function Breadcrumb_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, BreadcrumbItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.children = _t);
    } }, inputs: { noTrailingSlash: "noTrailingSlash", ariaLabel: "ariaLabel", skeleton: "skeleton", threshold: "threshold", items: "items" }, outputs: { navigation: "navigation" }, ngContentSelectors: _c0, decls: 5, vars: 8, consts: [[1, "bx--breadcrumb", 3, "ngClass"], ["nav", ""], [3, "ngIf"], [3, "href", "route", "routeExtras", "current", "ariaCurrent", "navigation", 4, "ngFor", "ngForOf"], [3, "href", "route", "routeExtras", "current", "ariaCurrent", "navigation"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "bx--overflow-menu-options__option", 4, "ngFor", "ngForOf"], [1, "bx--overflow-menu-options__option"], [1, "bx--overflow-menu-options__btn", 2, "text-decoration", "none", 3, "href", "click"]], template: function Breadcrumb_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nav", 0, 1);
        ɵngcc0.ɵɵtemplate(2, Breadcrumb_ng_template_2_Template, 1, 0, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(3, Breadcrumb_ng_template_3_Template, 1, 1, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(4, Breadcrumb_ng_template_4_Template, 12, 22, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c2, ctx.skeleton, ctx.noTrailingSlash));
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.shouldShowContent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldShowOverflow);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.shouldShowOverflow);
    } }, dependencies: [ɵngcc3.NgClass, ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc3.NgTemplateOutlet, ɵngcc5.OverflowMenu, BreadcrumbItemComponent], encapsulation: 2 });
/** @nocollapse */
Breadcrumb.ctorParameters = () => [
    { type: I18n },
    { type: Router, decorators: [{ type: Optional }] }
];
Breadcrumb.propDecorators = {
    children: [{ type: ContentChildren, args: [BreadcrumbItemComponent,] }],
    items: [{ type: Input }],
    noTrailingSlash: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    skeleton: [{ type: Input }],
    threshold: [{ type: Input }],
    navigation: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Breadcrumb, [{
        type: Component,
        args: [{
                selector: "ibm-breadcrumb",
                template: `
	<nav #nav class="bx--breadcrumb"
		[ngClass]="{
			'bx--skeleton' : skeleton,
			'bx--breadcrumb--no-trailing-slash' : noTrailingSlash
		}"
		[attr.aria-label]="ariaLabel">
		<ng-template [ngIf]="shouldShowContent">
			<ng-content></ng-content>
		</ng-template>
		<ng-template [ngIf]="!shouldShowOverflow">
			<ibm-breadcrumb-item
				*ngFor="let item of items"
				[href]="item.href"
				[route]="item.route"
				[routeExtras]="item.routeExtras"
				[current]="item.current"
				[ariaCurrent]="item.ariaCurrent"
				(navigation)="navigation.emit($event)">
				<ng-container *ngIf="!item.template">{{item.content}}</ng-container>
				<ng-template
					*ngIf="item.template"
					[ngTemplateOutlet]="item.template"
					[ngTemplateOutletContext]="{ $implicit: item }">
				</ng-template>
			</ibm-breadcrumb-item>
		</ng-template>
		<ng-template [ngIf]="shouldShowOverflow">
			<ibm-breadcrumb-item
				[href]="first?.href"
				[route]="first?.route"
				[routeExtras]="first?.routeExtras"
				[current]="first?.current"
				[ariaCurrent]="first?.ariaCurrent"
				(navigation)="navigation.emit($event)">
				<ng-container *ngIf="!first?.template">{{first?.content}}</ng-container>
				<ng-template
					*ngIf="first?.template"
					[ngTemplateOutlet]="first?.template"
					[ngTemplateOutletContext]="{ $implicit: first }">
				</ng-template>
			</ibm-breadcrumb-item>
			<ibm-breadcrumb-item>
				<ibm-overflow-menu>
					<li class="bx--overflow-menu-options__option"
						*ngFor="let item of overflowItems">
						<a class="bx--overflow-menu-options__btn"
							href="{{item?.href}}"
							(click)="navigate($event, item)"
							style="text-decoration: none;">
							<ng-container *ngIf="!item?.template">{{item?.content}}</ng-container>
							<ng-template
								*ngIf="item?.template"
								[ngTemplateOutlet]="item?.template"
								[ngTemplateOutletContext]="{ $implicit: item }">
							</ng-template>
						</a>
					</li>
				</ibm-overflow-menu>
			</ibm-breadcrumb-item>
			<ibm-breadcrumb-item
				[href]="secondLast?.href"
				[route]="secondLast?.route"
				[routeExtras]="secondLast?.routeExtras"
				[current]="secondLast?.current"
				[ariaCurrent]="secondLast?.ariaCurrent"
				(navigation)="navigation.emit($event)">
				<ng-container *ngIf="!secondLast?.template">{{secondLast?.content}}</ng-container>
				<ng-template
					*ngIf="secondLast?.template"
					[ngTemplateOutlet]="secondLast?.template"
					[ngTemplateOutletContext]="{ $implicit: secondLast }">
				</ng-template>
			</ibm-breadcrumb-item>
			<ibm-breadcrumb-item
				[href]="last?.href"
				[route]="last?.route"
				[routeExtras]="last?.routeExtras"
				[current]="last?.current"
				[ariaCurrent]="last?.ariaCurrent"
				(navigation)="navigation.emit($event)">
				<ng-container *ngIf="!last?.template">{{last?.content}}</ng-container>
				<ng-template
					*ngIf="last?.template"
					[ngTemplateOutlet]="last?.template"
					[ngTemplateOutletContext]="{ $implicit: last }">
				</ng-template>
			</ibm-breadcrumb-item>
		</ng-template>
	</nav>`
            }]
    }], function () { return [{ type: ɵngcc4.I18n }, { type: ɵngcc2.Router, decorators: [{
                type: Optional
            }] }]; }, { noTrailingSlash: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], navigation: [{
            type: Output
        }], skeleton: [{
            type: Input
        }], threshold: [{
            type: Input
        }], children: [{
            type: ContentChildren,
            args: [BreadcrumbItemComponent]
        }], items: [{
            type: Input
        }] }); })();

class BreadcrumbModule {
}
BreadcrumbModule.ɵfac = function BreadcrumbModule_Factory(t) { return new (t || BreadcrumbModule)(); };
BreadcrumbModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BreadcrumbModule });
BreadcrumbModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        DialogModule,
        I18nModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    Breadcrumb,
                    BreadcrumbItemComponent
                ],
                exports: [
                    Breadcrumb,
                    BreadcrumbItemComponent
                ],
                imports: [
                    CommonModule,
                    DialogModule,
                    I18nModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BreadcrumbModule, { declarations: function () { return [Breadcrumb, BreadcrumbItemComponent]; }, imports: function () { return [CommonModule,
        DialogModule,
        I18nModule]; }, exports: function () { return [Breadcrumb, BreadcrumbItemComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { Breadcrumb, BreadcrumbItemComponent, BreadcrumbModule };

